import { useNavigate, useParams } from "react-router-dom";
import "./Css/blogdetails.css";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AppContext } from "../../context/AppContext";

const BlogDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [blogDetails, setBlogDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [allBlogs, setAllBlogs] = useState([]);

  const adminurl = "http://localhost:4000/api";
  const { baseUrl, Backend_folder_path, blogId } = useContext(AppContext);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseUrl}/blog/${blogId}`)
      .then((res) => {
        setBlogDetails(res.data.blog);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API error:", err);
        setError("Failed to load blog post");
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/get-blog`)
      .then((res) => {
        setAllBlogs(res.data.getAllBlog);
      })
      .catch((err) => console.error("API error:", err));
  }, []);

  const relatedPosts = allBlogs.filter(
    (post) =>
      post.blogStatus === true &&
      post?.categoryType === blogDetails?.categoryType &&
      post.id !== blogDetails.id // Exclude the current post
  );

  // Share functionality
  const handleShare = (platform) => {
    if (!blogDetails) return;

    const url = window.location.href;
    const title = blogDetails.title;

    switch (platform) {
      case "twitter":
        window.open(
          `https://twitter.com/intent/tweet?text=${encodeURIComponent(
            title
          )}&url=${encodeURIComponent(url)}`
        );
        break;
      case "facebook":
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            url
          )}`
        );
        break;
      case "linkedin":
        window.open(
          `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
            url
          )}`
        );
        break;
      case "whatsapp":
        window.open(
          `https://wa.me/?text=${encodeURIComponent(title + " " + url)}`
        );
        break;
      case "telegram":
        window.open(
          `https://t.me/share/url?url=${encodeURIComponent(
            url
          )}&text=${encodeURIComponent(title)}`
        );
        break;
      case "copy":
        navigator.clipboard.writeText(url);
        alert("Link copied to clipboard!");
        break;
      default:
        break;
    }
    setShowShareMenu(false);
  };

  // Handle loading, error, or inactive post
  if (loading) {
    return <div className="blog-details-container">Loading...</div>;
  }

  if (error) {
    return <div className="blog-details-container">{error}</div>;
  }

  if (!blogDetails || blogDetails.blogStatus !== true) {
    return (
      <div className="blog-details-container">Post not found or inactive</div>
    );
  }

  const handlePostClick = (postId) => {
    navigate(`/blog/${postId}`);
  };

  return (
    <div className="blog_details_main">
      <div className="featured-image">
        <img
          src={
            blogDetails.imagePath
              ? `${Backend_folder_path}${blogDetails.imagePath}`
              : ""
          }
          alt={blogDetails.title || "Blog image"}
        />
      </div>
      <div className="container">
        <div className="blog-details-wrapper">
          <div className="floating-actions">
            {/* Share Button with Dropdown */}
            <div className="share-dropdown">
              <button
                className="share-toggle-btn"
                onClick={() => setShowShareMenu(!showShareMenu)}
                title="Share Article"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.70l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" />
                </svg>
              </button>

              {showShareMenu && (
                <div className="share-menu">
                  <button
                    onClick={() => handleShare("twitter")}
                    className="share-menu-item twitter"
                    title="Share on Twitter"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                    </svg>
                  </button>

                  <button
                    onClick={() => handleShare("facebook")}
                    className="share-menu-item facebook"
                    title="Share on Facebook"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  </button>

                  <button
                    onClick={() => handleShare("linkedin")}
                    className="share-menu-item linkedin"
                    title="Share on LinkedIn"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                  </button>

                  <button
                    onClick={() => handleShare("whatsapp")}
                    className="share-menu-item whatsapp"
                    title="Share on WhatsApp"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.464 3.488" />
                    </svg>
                  </button>

                  <button
                    onClick={() => handleShare("telegram")}
                    className="share-menu-item telegram"
                    title="Share on Telegram"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                    </svg>
                  </button>

                  <button
                    onClick={() => handleShare("copy")}
                    className="share-menu-item copy"
                    title="Copy Link"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                    </svg>
                  </button>
                </div>
              )}
            </div>

            <button
              className={`bookmark-btn ${isBookmarked ? "bookmarked" : ""}`}
              onClick={() => setIsBookmarked(!isBookmarked)}
              title="Bookmark"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z" />
              </svg>
            </button>
          </div>

          <div className="blog-details-container">
            <header className="article-header">
              <h1 className="article-title">{blogDetails.title}</h1>
              <div
                className="article-description"
                dangerouslySetInnerHTML={{ __html: blogDetails.description }}
              />
              <div className="article-meta">
                <div className="author-info">
                  <img
                    src={
                      blogDetails.authorImagePath
                        ? `${Backend_folder_path}${blogDetails.authorImagePath}`
                        : "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50&h=50&fit=crop&crop=face"
                    }
                    alt={blogDetails.authorName || "Author"}
                    className="author-avatar"
                  />
                  <div className="details">
                    <span className="author-name">
                      {blogDetails.authorName}
                    </span>
                    <div className="meta-details">
                      <span className="date">
                        {new Date(blogDetails.createdAt).toLocaleDateString(
                          "en-US",
                          {
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                          }
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </header>

            {/* Related Articles */}
            {relatedPosts.length > 0 && (
              <section className="related-articles">
                <h3>Related Articles</h3>
                <div className="related-grid">
                  {relatedPosts.slice(0, 3).map((relatedPost) => (
                    <article key={relatedPost.id} className="blog-card">
                      <div className="blog-image">
                        <img
                          src={
                            relatedPost.imagePath
                              ? `${Backend_folder_path}${relatedPost.imagePath}`
                              : ""
                          }
                          alt={relatedPost.title || "Related post"}
                        />
                        <div className="category-badge">
                          {relatedPost.categoryType}
                        </div>
                      </div>
                      <div className="blog-card-content">
                        <h2>{relatedPost.title}</h2>
                        <p
                          className="description"
                          dangerouslySetInnerHTML={{
                            __html: relatedPost.description,
                          }}
                        />
                        <div className="blog-meta">
                          <div className="meta-left">
                            <span className="author">
                              {relatedPost.authorName}
                            </span>
                            <span className="date">
                              {new Date(
                                relatedPost.createdAt
                              ).toLocaleDateString("en-US", {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                              })}
                            </span>
                          </div>
                        </div>
                        <div
                          className="read-more"
                          onClick={() => handlePostClick(relatedPost.id)}
                        >
                          Read More
                        </div>
                      </div>
                    </article>
                  ))}
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
